import {
  Box,
  Button,
  Popover,
  TextField,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { toastError } from '../../../../components/notifications';

interface Props {
  anchorEl: HTMLElement | null
  onClose: () => void
  onSave: (name: string, description?: string) => void
}

const SaveApprovalConfigurationPopover: React.FC<Props> = ({
  anchorEl,
  onClose,
  onSave,
}) => {
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');

  const open = Boolean(anchorEl);

  useEffect(() => {
    if (!open) {
      setName('');
      setDescription('');
    }
  }, [open]);

  const handleSave = () => {
    const trimmedName = name?.trim();
    if (!trimmedName || trimmedName.length <= 2) {
      toastError('Name for this configuration is required');
      return;
    }
    onSave(trimmedName, description.trim());
  };

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: 'top',
        horizontal: 'center',
      }}
      transformOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
    >
      <Box p={2} width={360}>
        <TextField
          fullWidth
          label="Configuration Name"
          value={name}
          onChange={(e) => setName(e.target.value)}
          margin="normal"
          required
        />

        <TextField
          fullWidth
          multiline
          rows={3}
          label="Description"
          value={description}
          onChange={(e) => setDescription(e.target.value)}
          margin="normal"
        />

        <Box mt={2}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            disabled={!name.trim()}
            onClick={handleSave}
          >
            Save Configuration
          </Button>
        </Box>
      </Box>
    </Popover>
  );
};

export default SaveApprovalConfigurationPopover;
